import { Button, Notice, SkeletonText } from "./design";
import useTranslator from "../hooks/useTranslator";
import { useTenantDocumentListsStatus } from "../hooks/useTenantDocumentLists";

// Shows its children only once the document lists are loaded (see
// src/context/tenantDocumentLists). They load when the app opens, so this is
// usually immediate. Until then a placeholder; if they cannot be loaded, a
// message with a retry button.
const TenantDocumentListsGate = ({ children }) => {
  const { _t } = useTranslator();
  const { status, retry } = useTenantDocumentListsStatus();

  if (status === "ready") return children;

  if (status === "error") {
    return (
      <Notice
        tone="danger"
        action={
          <Button size="sm" variant="outline" onClick={retry}>
            {_t("retry")}
          </Button>
        }
      >
        {_t("documentListsLoadFailed")}
      </Notice>
    );
  }

  return <SkeletonText lines={4} label={_t("loading")} />;
};

// For a component that needs the lists from its first render:
//   export default withTenantDocumentLists(MyComponent);
export const withTenantDocumentLists = (Component) => {
  const WithTenantDocumentLists = (props) => (
    <TenantDocumentListsGate>
      <Component {...props} />
    </TenantDocumentListsGate>
  );
  WithTenantDocumentLists.displayName = `withTenantDocumentLists(${
    Component.displayName || Component.name || "Component"
  })`;
  return WithTenantDocumentLists;
};

export default TenantDocumentListsGate;
